import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { TeamResource } from 'dy-frontend-http-repository/lib/modules/Team/resources';
import { resetTeams } from './events';
import domain from './domain';

// Teams
export const $teams = domain.createStore<CollectionResource<TeamResource, {}> | null>(null).reset(resetTeams);
